import BaseModel from "./BaseModel";

class PreliminaryReportModel extends BaseModel {
  id: number = 0;
  parent: number = 0;
  report: number = 0;
  year: number = 0;
  status: string = "";
  organization: string = "";
  hcpIndAmount: number = 0;
  hcpGrpAmount: number = 0;
  hcpEventTotal: number = 0;
  hcpSalaryTotal: number = 0;
  hcoIndAmount: number = 0;
  hcoGrpAmount: number = 0;
  hcoDonationTotal: number = 0;
  hcoEventTotal: number = 0;
  hcoSalaryTotal: number = 0;
  rndCost: number = 0;
  q_1: string = "";
  q_2: string = "";
  q_3: string = "";
  q_4: string = "";
  organizationComments: string = "";
  draft: boolean = false;

  constructor(options?: object) {
    super(options);
    this.setData(options);
  }

  get hcpTotal() {
    return this.hcpEventTotal + this.hcpSalaryTotal;
  }

  get hcpEventPercent() {
    return this.hcpTotal ? this.hcpEventTotal / this.hcpTotal : 0;
  }

  get hcpSalaryPercent() {
    return this.hcpTotal ? this.hcpSalaryTotal / this.hcpTotal : 0;
  }

  get hcoTotal() {
    return this.hcoEventTotal + this.hcoSalaryTotal + this.hcoDonationTotal;
  }

  get hcoDonationPercent() {
    return this.hcoTotal ? this.hcoDonationTotal / this.hcoTotal : 0;
  }

  get hcoEventPercent() {
    return this.hcoTotal ? this.hcoEventTotal / this.hcoTotal : 0;
  }

  get hcoSalaryPercent() {
    return this.hcoTotal ? this.hcoSalaryTotal / this.hcoTotal : 0;
  }
}

export default PreliminaryReportModel;
